import styled from "styled-components";

import { Button } from "../Banner/index.style";

import {
  borderRadius,
  boxShadowColor,
  lightColor,
  secondaryColor,
  primaryColor,
} from "../variables.styles";

// Holds everything about plans
export const PlanContainer = styled.div`
  padding: 4rem 2rem;
  text-align: center;
  background: ${lightColor};

  h2,
  p {
    grid-column: 1 / -1;
  }

  h2 {
    color: ${primaryColor};
    font-weight: bold;
    text-transform: uppercase;
  }

  p {
    font-size: 1.7rem;
  }

  @media (min-width: 600px) {
    display: grid;
    grid-template-columns: 1fr minmax(300px, 350px) minmax(300px, 350px) 1fr;
    grid-gap: 3rem;
    place-content: center;
  }
`;

// Header section for the plans
export const HeaderSection = styled.div`
  text-align: left;
  padding-bottom: 2rem;
  h3 {
    text-transform: uppercase;
    font-weight: bold;
  }

  &::after {
    content: "";
    display: block;
    height: 1.5px;
    width: 7rem;
    background: rgba(255, 255, 255, 0.5);
  }
`;

// plan button style
export const PlanButton = styled(Button)`
  background-color: ${lightColor};
  display: inline-block;
  width: 100%;
  text-transform: capitalize;
`;

export const PlanCard = styled.div`
  grid-column: 2;
  background-color: ${secondaryColor};
  padding: 2rem;
  margin-bottom: 2rem;
  text-align: left;
  color: ${lightColor};
  border-radius: ${borderRadius};
  box-shadow: 0 0 3px 2px ${boxShadowColor};
  transition: transform 0.5s ease-out;
  &:hover {
    transform: scale(1.1);
  }
`;

// contains information about the Standard plan
export const Standard = styled(PlanCard)`
  grid-column: 2;
  background-color: ${secondaryColor};
}
`;

// customised button for StandardButton
export const StandardButton = styled(PlanButton)`
  color: ${secondaryColor};
  }
`;

// contains everything about professional plan
export const Professional = styled(PlanCard)`
  grid-column: 3;
  background: ${primaryColor};
`;

// customised professional button
export const ProfessionalButton = styled(PlanButton)`
  color: ${primaryColor};
  &:hover,
  &:link,
  &:active,
  &:visited {
    color: ${primaryColor};
  }
`;

export const PriceSection = styled.div`
  text-align: left;
  padding-bottom: 2rem;
  line-height: 1;
  p {
    font-size: 4rem;
    font-weight: bold;
  }
  span {
    font-size: 1.2rem;
  }
  &::after {
    content: "";
    display: block;
    height: 1px;
    width: 7rem;
    background: rgba(255, 255, 255, 0.5);
  }
`;

export const Items = styled.ul`
  padding: 1rem 2rem 1rem 2rem;
  li {
    padding-left: 1rem;
    line-height: 2;
  }
`;
